
/* eslint-disable @typescript-eslint/camelcase */
import { Vue, Options } from "vue-class-component";
import DetailSender from "./components/detail-sender/index.vue";
import DetailReceiver from "./components/detail-receiver/index.vue";
import DetailKoli from "./components/detail-koli/index.vue";
import Product from "./components/delivery-type/product/index.vue";
import CommoditySection from "./components/comodity/index.vue";
import DeliveryService from "./components/delivery-service/index.vue";
import SectionFooterBookingV3 from "./components/footer/index.vue";
import BannerProductType from "./components/banner-product-type/index.vue";
import SttManualReference from "./components/stt-manual-reference/index.vue";
import InsuranceBanner from "./components/banner-product-type/index.vue";
import DeliveryType from "./components/delivery-type/product/index.vue";
import DocInternational from "./components/booking-extra/doc-international/index.vue";
import SectionUploadPhotoForWeightAdjusment from "@/app/ui/components/section-upload-photo-for-weight-adjustment/index.vue";
import FilterClient from "./components/filter-client/index.vue";
import {
  DocInternationalModelValueType,
  ErrorBookingV3,
  BookingV3,
  CommodityBookingV3,
  FraudStatus,
  PosterProduct,
  ConfigValidationForm,
  CommodityCIPL,
  SuccessBooking
} from "@/domain/entities/CreateBookingV3";
import { OptionsClass, ApiRequestList, UploadMultiple } from "@/domain/entities/MainApp";
import { CountryData, DistrictData, ZipCodeEntities } from "@/domain/entities/Location";
import { BookingController } from "@/app/ui/controllers/BookingController";
import {
  SubmitPosterProductApiRequest,
  GetEstimationPrice,
  CreateBookingV3Retail,
  EditBookingV3
} from "@/data/payload/api/BookingRequest";
import {
  EstimationPrice,
  PayloadPosterProduct,
  ComodityProductPoster,
  PiecesPosterProduct,
  InsuranceTypeDeliveryData
} from "@/domain/entities/Booking";
import { LocationController } from "@/app/ui/controllers/LocationController";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { FlagsMedusa } from "@/feature-flags/flags-misc-medusa";
import { FlagsPermissionBooking } from "@/feature-flags/flag-booking";
import { CodInternationalCountry, DetailCodConfigurationRetail } from "@/domain/entities/CodConfiguration";
import { HeavyWeightSurchargeController } from "@/app/ui/controllers/HeavyWeightSurchargeController";
import { ProductController } from "@/app/ui/controllers/ProductController";
import { ProductConfigurationRule } from "@/domain/entities/Product";
import {
  HeavyWeightSurchargeData,
  HeavyWeightSurchargeDetailMinimum
} from "@/domain/entities/HeavyWeightSurcharge";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { CodConfigurationController } from "@/app/ui/controllers/CodConfigurationController";
import { debounce } from "lodash";
import { ProductConfigurationRuleRequestParams } from "@/data/payload/api/ProductApiRequest";
import { PromoConfigurationController } from "@/app/ui/controllers/PromoConfigurationController";
import { PromoConfigurationListRequest } from "@/data/payload/api/PromoConfigurationApiRequest";
import { InsuranceController } from "@/app/ui/controllers/InsuranceController";
import SectionFilterClient from "@/app/ui/views/shipment/booking/create-booking-v2/components/section-filter-client.vue";
import {
  DeleteHydraFileRequest,
  UploadHydraFileRequest
} from "@/data/payload/api/BookingRequest";
import {
  formatInputByCountry,
  formatByCountry,
  formatInputMoney,
  formatInputMoneyWithDecimal,
  getDataLocalStorage,
  parseByCountry,
  parsingErrorResponse,
  storeDatatoLocalStorage
} from "@/app/infrastructures/misc/Utils";
import { flags } from "@/feature-flags";
import { ShipmentBookingController } from "@/app/ui/controllers/ShipmentBookingController";
import {
  SttReferenceAdjustment,
  SttAdjustment,
  ShipmentBookingDetail
} from "@/domain/entities/ShipmentBooking";
import { Insurance } from "@/domain/entities/Insurance";
import { RequestInternationalDocumentDetail } from "@/domain/entities/InternationalDocument";
import { parseZodError, parseMultiFieldZodError } from "./utils";
import {
  emailSchema,
  idNumberSchema,
  taxNumberSchema,
  imageSchema,
  itemDetailSchema,
  quantitySchema,
  goodsPriceSchema
} from "./components/booking-extra/doc-international/validation";
import {
  sttReferenceSchema,
  noSttSchema
} from "./components/stt-manual-reference/validationSttManualReference";
import {
  senderSchema,
  senderPhoneSchema,
  senderAddressSchema,
  senderReceiverSchema
} from "./components/detail-sender/validation";
import {
  receiverSchema,
  receiverPhoneSchema,
  receiverAddressSchema,
  receiverDestinationCitySchema,
  receiverPostalCodeSchema
} from "./components/detail-receiver/validation";
import { commoditySchema } from "./components/comodity/validation-commodity";
import {
  totalGrossWeightSchema,
  totalVolumeWeightSchema
} from "./components/detail-koli/weight-koli/validation";
import { InternationalDocumentController } from "@/app/ui/controllers/InternationalDocumentController";
import { DetailClientManagement } from "@/domain/entities/ClientManagement";
import { ClientManagementController } from "@/app/ui/controllers/ClientManagementController";
import { CommodityController } from "@/app/ui/controllers/CommodityController";
import { Commodity } from "@/domain/entities/Commodity";
import { CreateBookingV3Controller } from "@/app/ui/controllers/CreateBookingV3Controller";
import { Pagination } from "@/domain/entities/Pagination";
import { FlagsPermissionBookingV3 } from "@/feature-flags/flag-booking-v3";
import { createFocusTrap } from "focus-trap";
import {
  estimationPriceSchema,
  getMinMaxGoodsPriceFromFlag
} from "./components/detail-koli/product-price-insurance/validation";
import formatPriceRP from "@/app/infrastructures/misc/common-library/v2/FormatPriceRP";
import formatPriceRM from "@/app/infrastructures/misc/common-library/v2/FormatPriceRM";
import { getRoundedChargeableWeightByRules } from '@/app/infrastructures/misc/common-library/getRoundedChargeableWeightByRules';
import { payloadBookingCorporate } from "../../bulk-booking-v2/components/footer-edit-bulk-booking/module";
import { shouldSkipPhoneValidation } from "../booking-utils";
import { getCurrencyCodeByCountry } from "@/app/infrastructures/misc/common-library/modules/Price";

interface Diskon {
  isDiscount: boolean;
  totalTariff: number;
  totalAfterDiscount: number;
  totalBeforeDiscount: number;
}

@Options({
  components: {
    DetailSender,
    DetailReceiver,
    DetailKoli,
    Product,
    CommoditySection,
    DeliveryService,
    SectionFooterBookingV3,
    BannerProductType,
    SttManualReference,
    InsuranceBanner,
    DeliveryType,
    SectionFilterClient,
    DocInternational,
    SectionUploadPhotoForWeightAdjusment,
    FilterClient
  },
  watch: {
    form: {
      handler(newVal) {
        this.getInsuranceConfig();

        if (JSON.stringify(newVal) !== JSON.stringify(this.originalForm)) {
          CreateBookingV3Controller.setDirty(true);
        }
      },
      deep: true
    },
    originCountry() {
      this.getInsuranceAvailability();
    },
    "form.serviceType"(serviceTypeValue: string) {
      this.form.isCOD =
        serviceTypeValue === "cod" || serviceTypeValue === "dfod";
      this.form.isDFOD = serviceTypeValue === "dfod";
    },
    upsellingPayload: {
      handler() {
        this.getUpsellingDataDebounced();
      },
      deep: true
    },
    estimationPricePayload: {
      handler() {
        this.getEstimationPriceDebounced();
      },
      deep: true
    },
    promoConfigPayload: {
      handler() {
        this.getPromoConfig();
      },
      deep: true
    }
  }
})
 class EditBooking extends Vue {
  currentIndex = 0;
  maxPieces = 15;
  paymentMethod = "";
  form = new BookingV3();
  originalForm = new BookingV3();
  loadingBeforeDirty = true;
  showWarningHws = false;
  insuranceData = new Insurance();
  isErrorUpselling = false;

  configRuleAdjustStt = new SttReferenceAdjustment({
    config: new SttAdjustment()
  });
  tempTotalPieces: any = [];
  isShowModalSuccessBooking = false;
  isShowModalFailedBooking = false;
  errorCause = "";
  focusTrap: any = null;

  created() {
    window.addEventListener("keydown", this.onEnterBooking);
  }

  get isError() {
    return ShipmentBookingController.isError;
  }
  get errorDetail() {
    return ShipmentBookingController.isErrorCause;
  }

  async mounted() {
    this.isLoading = true;
    await this.getCODConfig();
    await this.getInsuranceAvailability();
    await this.getDetail();
    await this.getAdjustmentStt();
    await this.getHWSConfig();
    await this.getRoundingRulesConfig();
    await this.onCheckDisableWeightAdjustment();
    await this.getEstimationPrice();
    this.isLoading = false;
    storeDatatoLocalStorage("list-kg", this.form.pieces);
    this.listKGsDefault = JSON.parse(getDataLocalStorage("list-kg") || "[]");
  }

  unmounted() {
    window.removeEventListener("keydown", this.onEnterBooking);
    if (this.focusTrap) {
      this.focusTrap.deactivate();
      this.focusTrap = null;
    }
  }

  listKGsDefault: any[] = [];

  error = new ErrorBookingV3();
  errorFtz = new ErrorBookingV3();
  errorDocInternational = new ErrorBookingV3();

  upsellingData: any[] = [];
  loadingUpsellingData = false;

  ccoCodProducts = "";
  ccoCodActive = new DetailCodConfigurationRetail();
  ccoDfodProducts = "";
  ccoDfodActive = new DetailCodConfigurationRetail();
  configurationRules: ProductConfigurationRule[] = [];
  heavyWeightSurchargeConfig = new HeavyWeightSurchargeData();
  estimationPriceData = new EstimationPrice();
  loadingEstimationPrice = false;
  errorEstimationPrice = false;
  isErrorClient = false;
  internationalDocumentDetailData = new RequestInternationalDocumentDetail();
  fetchPromisesAfterGetUpselling: string[] = [];
  clientManagementDetail = new DetailClientManagement();
  isFirstRender = true;
  tempProductName = "";
  errorRouteNotFound = false;
  isLoading = false;
  configCodInternationalClient = new DetailCodConfigurationRetail();

  get listProducts() {
    if (this.formType === "client") {
      let clientProduct: string[] = this.accountCountryCode.toUpperCase() === 'MY' ? FlagsPermissionBookingV3.config_upselling_product_list.getValue()
      .countries.MY.edit_client : FlagsPermissionBookingV3.config_upselling_product_list.getValue()
        .edit_client;
      if (!FlagsPermissionBooking.config_show_bigpack_fast.isEnabled()) {
        clientProduct = clientProduct.filter(
          (product) => product !== "BIGPACKFAST"
        );
      }
      return clientProduct;
    }
    let retailProducts: string[] = this.accountCountryCode.toUpperCase() === 'MY' ? FlagsPermissionBookingV3.config_upselling_product_list.getValue()
      .countries.MY.edit_retail : FlagsPermissionBookingV3.config_upselling_product_list.getValue()
      .edit_retail;
    if (
      !AccountController.accountData.account_type_detail
        ?.partnerIsAllowBookVippack &&
      AccountController.accountData.account_type === "partner"
    ) {
      retailProducts = retailProducts.filter(
        (product) => product !== "VIPPACK"
      );
    }
    if (!FlagsPermissionBooking.config_show_bigpack_fast.isEnabled()) {
      retailProducts = retailProducts.filter(
        (product) => product !== "BIGPACKFAST"
      );
    }
    return retailProducts;
  }

  get configRule() {
    return this.configRuleAdjustStt.config;
  }

  get heavyWeightSurchargeMinimumConfigData() {
    const productName = this.form.productName || this.tempProductName;
    if (!this.heavyWeightSurchargeConfig.configurableHeavyWeight)
      return new HeavyWeightSurchargeDetailMinimum();
    const isActive =
      this.heavyWeightSurchargeConfig.configurablePriceStatus.toLowerCase() ===
      "active";
    const product = this.heavyWeightSurchargeConfig.configurableHeavyWeight.heavy_weight_surcharge_product_include.product_types.includes(
      productName.toUpperCase()
    );
    const isEnableHwsConfig = FlagsPermissionBooking.hws_configuration.isEnabled();
    const commodity = this.heavyWeightSurchargeConfig.configurableHeavyWeight.heavy_weight_surcharge_commodity_exclude.commodities.find(
      (item: any) =>
        item.commodity_code === this.form.commodity.code ||
        item.commodity_name === this.form.commodity.name
    );

    const otherCondition = product && !commodity;
    const isSetMinimumHws = isActive && otherCondition && isEnableHwsConfig;
    if (isSetMinimumHws) {
      return new HeavyWeightSurchargeDetailMinimum({
        heavyWeightMinimum: this.heavyWeightSurchargeConfig
          .configurableHeavyWeight.heavy_weight_surcharge_additional_cost
          .additional_costs[0]?.weight_min,
        minimumExist: true
      });
    }

    return new HeavyWeightSurchargeDetailMinimum();
  }

  get errorMandatoryClientColumn() {
    return this.configRuleAdjustStt.config.client.isRequired;
  }

  get title() {
    return this.$t(`${this.$route.meta.name}`);
  }

  goBack() {
    this.$router.push(`${this.customPath}`);
  }

  get formType() {
    return this.manualBookingData.sttBookedForType === "client"
      ? "client"
      : "manual";
  }

  get isCustomerApps() {
    return (
      this.manualBookingData.sttBookedFor.toLowerCase() === "customer apps"
    );
  }

  get isConsoleAndSubconsoleAccount() {
    return (
      AccountController.accountData.isConsoleAccount ||
      AccountController.accountData.isSubConsoleAccount
    );
  }

  get customPath() {
    return this.$route.meta.customPath && this.isConsoleAndSubconsoleAccount
      ? `/shipment/${this.$route.meta.customPath}`
      : this.$route.meta?.bookingPath;
  }

  get districtDetail() {
    return LocationController.districtDetail;
  }

  get originCityCode() {
    return this.districtDetail.cityCode;
  }

  get originCountryCode(): string {
    const code =
      LocationController.districtDetail?.countryCode ||
      AccountController.accountData.countryCode;
    return (code || "ID").toUpperCase();
  }

  get isCrossCountryRoute(): boolean {
    return (
      !!this.destinationCity?.id &&
      this.destinationCity.countryCode !== this.originCountryCode &&
      this.isClient
    );
  }

  get isCrossCountryCod(): boolean {
    return this.isCrossCountryRoute && (this.form.isCOD || this.form.isDFOD);
  }

  get effectiveCurrencyCode(): string {
    if (this.isCrossCountryCod) {
      return getCurrencyCodeByCountry(this.destinationCity.countryCode);
    }
    return "";
  }

  get prefixCurrency() {
    if (this.isCrossCountryCod) {
      return (
        this.form.destinationCountry.currencySymbol
      );
    }

    return "Rp";
  }

  get isAccountPosOrInternal() {
    const account = AccountController.accountData;
    return account.isPosAccount || account.isInternalAccount;
  }

  get isFtzAccount() {
    return (
      AccountController.accountData.account_location?.city_free_trade_zone ===
        "yes" || this.form.ftzForm.listCommodityCIPL?.length > 0
    );
  }

  get isInterpackAdditionalInfo() {
    return FlagsMedusa.flag_release_interpack_additional_info.isEnabled();
  }

  get eligibleAdditionalInfo() {
    if (!this.destinationCity.id || !this.form.productName) return false;
    return (
      this.isInterpackAdditionalInfo &&
      (this.form.productName.toUpperCase() === "INTERPACK" ||
        this.form.productName.toUpperCase() === "INTERPACKMAXI")
    );
  }

  get isBlacklist() {
    return BookingController.phoneCheckerData.isBlacklist;
  }

  get isLimited() {
    return (
      BookingController.phoneCheckerData.status === FraudStatus.LIMITED &&
      FlagsPermissionBooking.disable_cod_dfod_for_limited_number.isEnabled()
    );
  }

  get postalCodeDestination() {
    return this.form.postalCodeDestination instanceof DistrictData
      ? this.form.postalCodeDestination
      : new DistrictData();
  }

  get minMaxConfig() {
    return getMinMaxGoodsPriceFromFlag(this.schemaGoodsPriceType);
  }

  get isSenderPhoneNonEditable() {
    return this.configRule.senderPhone.rule.includes(
      this.configValidationForm.NON_EDITABLE
    );
  }

  get isRecipientPhoneNonEditable() {
    return this.configRule.recipientPhone.rule.includes(
      this.configValidationForm.NON_EDITABLE
    );
  }

  get codConfigByDestination() {
    return new CodInternationalCountry(
      this.configCodInternationalClient.countries.find(
        (c) => c.countryCode === this.form.destinationCountry.code
      )
    );
  }

  get isFormValid() {
    const price = this.parseNumber(this.form.estimationPrice);
    let min = 0;
    let max = 0;

    if (this.isCrossCountryCod) {
      const { minPrice, maxPrice } = this.codConfigByDestination;

      min = Number(minPrice);
      max = Number(maxPrice);
    } else {
      const { min: minPrice, max: maxPrice } = this.minMaxConfig;

      min = minPrice;
      max = maxPrice;
    }
    const formValidation = {
      isSttReferenceValid: this.form.referenceExternal
        ? !parseZodError(sttReferenceSchema, this.form.referenceExternal)
        : true,
      isSttManualValid: this.form.sttManual,
      isSenderNameValid: !parseZodError(senderSchema, this.form.sender),
      isSenderPhoneValid:
        shouldSkipPhoneValidation(
          this.form.phoneSender,
          this.isSenderPhoneNonEditable
        ) || !parseZodError(senderPhoneSchema, this.form.phoneSender),
      isSenderAddressValid: !parseZodError(senderAddressSchema, this.form.addressSender),
      isSenderRecipientAddressValid: !parseMultiFieldZodError(senderReceiverSchema, {
        addressSender: this.form.addressSender,
        addressReceiver: this.form.addressReceiver
      }, "addressSender"),
      isRecipientNameValid: !parseZodError(receiverSchema, this.form.receiver),
      isRecipientPhoneValid:
        shouldSkipPhoneValidation(
          this.form.phoneReceiver,
          this.isRecipientPhoneNonEditable
        ) || !parseZodError(receiverPhoneSchema, this.form.phoneReceiver),
      isRecipientAddressValid: !parseZodError(receiverAddressSchema, this.form.addressReceiver),
      isRecipientDestinationValid: !parseZodError(receiverDestinationCitySchema, {
        destination: this.destinationCity.name,
        embargo: this.form.destinationIsEmbargo,
        unavailable: this.form.destinationIsUnavailable
      }),
      isRecipientPostalCodeValid: this.form.sttShipmentId ? true : !parseZodError(receiverPostalCodeSchema, this.postalCodeDestination.name),
      isCommodityValid: !parseZodError(commoditySchema, this.form.commodity),
      isServiceTypeValid: !!this.form.serviceType,
      isProductNameValid: !!this.form.productName,
      isDocInternationalValid: this.eligibleAdditionalInfo
        ? this.isDocInternationalFormValid
        : true,
      isFtzValid: this.isFtzAccount ? this.isFtzFormValid : true,
      isTotalGrossWeightValid: this.form.pieces.every((piece: any) => !parseZodError(totalGrossWeightSchema, this.parseNumber(piece.grossWeight))),
      isTotalVolumeWeightValid: this.form.pieces.every((piece: any) => !parseZodError(totalVolumeWeightSchema, this.parseNumber(piece.volumeWeight))),
      isMaxKoliValid: !(this.form.pieces.length > this.maxPieces),
      isDisabledWeightAdjustment: this.form.pieces.every(
        (item: any) =>
          item.errorGrossWeight === undefined || item.errorGrossWeight === ""
      ),
      isNotEmbargo: !this.isErrorEmbargoDestination,
      errorChWeightMaxGapShipmentMp: !CreateBookingV3Controller.errorChWeightMaxGapShipmentMp,
      isDirty: CreateBookingV3Controller.isDirty && !this.loadingBeforeDirty,
      isEstimationPriceValid: !parseZodError(estimationPriceSchema, {
        estimationPrice: String(price),
        minEstimationPrice: min,
        maxEstimationPrice: max,
        productName: this.form.productName,
        listCodActive: this.ccoCodActive,
        listDfodActive: this.ccoDfodActive,
        deliveryFeeType: this.deliveryFeeType,
        isFormBookClient: this.schemaGoodsPriceType === "client"
      })
    };

    return !Object.values(formValidation).includes(false);
  }

  get isFtzFormValid() {
    const validation = {
      isEmailValid: !parseZodError(
        emailSchema(false, true, this.form.ftzForm.email),
        this.form.ftzForm.email
      ),
      isIdentityNumberValid: !parseZodError(
        idNumberSchema(false),
        this.form.ftzForm.idNumber
      ),
      isTaxNumberValid: !parseZodError(
        taxNumberSchema(false, true, this.form.ftzForm.taxNumber),
        this.form.ftzForm.taxNumber
      ),
      isIdentityImageValid: !parseZodError(
        imageSchema(false, this.form.ftzForm.imageIdUrl),
        this.form.ftzForm.imageIdUrl
      ),
      isTaxImageValid: !parseZodError(
        imageSchema(false, this.form.ftzForm.imageTaxUrl),
        this.form.ftzForm.imageTaxUrl
      ),
      isBeforePackingImageValid: !parseZodError(
        imageSchema(false, this.form.ftzForm.imageBeforePackingUrl),
        this.form.ftzForm.imageBeforePackingUrl
      ),
      isAfterPackingImageValid: !parseZodError(
        imageSchema(false, this.form.ftzForm.imageAfterPackingUrl),
        this.form.ftzForm.imageAfterPackingUrl
      ),
      isCIPLValid: this.validateCIPL(true)
    };

    return !Object.values(validation).includes(false);
  }

  get isDocInternationalFormValid() {
    const validation = {
      isEmailValid: !parseZodError(
        emailSchema(
          this.internationalDocumentDetailData.email,
          false,
          this.form.docInternationalForm.email
        ),
        this.form.docInternationalForm.email
      ),
      isIdentityNumberValid: !parseZodError(
        idNumberSchema(
          this.internationalDocumentDetailData.idcIsIdentityNumber
        ),
        this.form.docInternationalForm.idNumber
      ),
      isTaxNumberValid: !parseZodError(
        taxNumberSchema(
          this.internationalDocumentDetailData.idcIsTaxIdentificationNumber,
          false,
          this.form.docInternationalForm.taxNumber,
          100,
          1
        ),
        this.form.docInternationalForm.taxNumber
      ),
      isIdentityImageValid: !parseZodError(
        imageSchema(
          this.internationalDocumentDetailData.ktp,
          this.form.docInternationalForm.imageIdUrl
        ),
        this.form.docInternationalForm.imageIdUrl
      ),
      isTaxImageValid: !parseZodError(
        imageSchema(
          this.internationalDocumentDetailData.npwp,
          this.form.docInternationalForm.imageTaxUrl
        ),
        this.form.docInternationalForm.imageTaxUrl
      ),
      isBeforePackingImageValid: !parseZodError(
        imageSchema(
          this.internationalDocumentDetailData.afterPacking,
          this.form.docInternationalForm.imageBeforePackingUrl
        ),
        this.form.docInternationalForm.imageBeforePackingUrl
      ),
      isAfterPackingImageValid: !parseZodError(
        imageSchema(
          this.internationalDocumentDetailData.afterPacking,
          this.form.docInternationalForm.imageAfterPackingUrl
        ),
        this.form.docInternationalForm.imageAfterPackingUrl
      ),
      isCIPLValid: this.validateCIPL()
    };

    return !Object.values(validation).includes(false);
  }

  get clientlientIdForProductUpselling() {
    let accountRefId = 0;
    let accountType = "";

    if (this.isClient) {
      accountType = "client";
      accountRefId = this.form.clientName.clientId;
    } else {
      accountType = "pos";
      accountRefId = this.manualBookingData.sttBookedForId;
    }

    return {
      accountRefId,
      accountType
    };
  }

  parseNumber(value: string): number {
    return parseByCountry(value, {
      country: this.isCrossCountryCod
        ? this.form.destinationCountry.code
        : this.accountCountryCode
    });
  }

  get goodsPrice(): number {
    return this.parseNumber(this.form.estimationPrice || "0");
  }

  get codAmount() {
    return Math.max(
      ["cod", "dfod"].includes(this.form.serviceType) ? 1 : 0,
      Number(
        this.form.codAmount
          ? this.parseNumber(this.form.codAmount)
          : this.goodsPrice
      )
    );
  }

  get upsellingPayload() {
    return new SubmitPosterProductApiRequest({
      payload: new PayloadPosterProduct({
        originId: this.districtDetail.code as any,
        destinationId: (this.form.destinationCity as DistrictData)
          .code as string,
        commodity:
          typeof this.form.commodity === "object"
            ? {
                data: new ComodityProductPoster({
                  commodityId: +(this.form.commodity.id as number),
                  commodityName: this.form.commodity?.name,
                  commodityCode: this.form.commodity?.code
                })
              }
            : { data: new ComodityProductPoster() },
        commodityId:
          typeof this.form.commodity === "object"
            ? (this.form.commodity.id as number)
            : 499,
        isCod:
          this.form.serviceType === "cod" || this.form.serviceType === "dfod",
        isDfod: this.form.serviceType === "dfod",
        codAmount: this.codAmount,
        goodsPrice: this.goodsPrice,
        pieces: this.form.pieces?.map(
          (piece: any) =>
            new PiecesPosterProduct({
              pieceWidth: piece.dimension.width,
              pieceLength: piece.dimension.length,
              pieceHeight: piece.dimension.height,
              pieceGrossWeight: this.parseNumber(piece.grossWeight)
            })
        ),
        accountType: this.clientlientIdForProductUpselling.accountType,
        accountRefId: this.clientlientIdForProductUpselling.accountRefId,
        isBookingPuposes: false,
        insuranceType: this.form.insurance,
        isWoodpacking: this.form.woodpacking
      })
    });
  }

  get isCODDisabled() {
    // catatan: tidak perlu disable cod by config;
    // if (this.ccoCodActive.ccoStatus !== "active") return true;
    // return !this.ccoCodProducts.includes(this.form.productName);
    return false;
  }

  get isDFODDisabled() {
    // catatan: tidak perlu disable cod by config;
    // if (this.ccoDfodActive.ccoStatus !== "active") return true;
    // return !this.ccoDfodProducts.includes(this.form.productName);
    return false;
  }

  get totalGrossWeight() {
    return this.form.pieces.reduce(
      (prev, curr: any) => prev + this.parseNumber(curr.grossWeight),
      0
    );
  }

  get totalVolumeWeight() {
    return this.form.pieces.reduce(
      (prev, curr: any) =>
        prev + this.parseNumber(curr.convertVolumeWeight),
      0
    );
  }

  get chargeableWeight() {
    return this.estimationPriceData.chargeableWeight;
  }

  get insuranceType() {
    return this.isClient ? "insurance-client" : "insurance-retail";
  }

  get isClient() {
    return this.form.clientName.clientName && this.isAccountPosOrInternal || AccountController.accountData.isAllClient;
  }

  get pieces() {
    return this.form.pieces?.map((key: any) => ({
      stt_piece_length: key.dimension.length,
      stt_piece_width: key.dimension.width,
      stt_piece_height: key.dimension.height,
      stt_piece_gross_weight: this.parseNumber(key.grossWeight.toString()),
      stt_piece_volume_weight: this.parseNumber(key.volumeWeight.toString()),
      stt_piece_id: key.pieceId
    })) as any;
  }

  get docInternationalCommodityCipl() {
    const list = this.form.docInternationalForm.listCommodityCIPL || [];

    const hasAnyValue = list.some((cipl: any) => {
      const hasQuantity = !!cipl?.quantity;
      const hasPrice = !!cipl?.goodsPrice;
      const hasName = !!(
        cipl?.commodity?.nameEn ||
        cipl?.commodity?.nameId ||
        cipl?.name
      );

      return hasQuantity || hasPrice || hasName;
    });

    if (!hasAnyValue) return [];

    return list.map((cipl: any) => ({
      quantity: parseByCountry(cipl.quantity.toString(), { country: this.accountCountryCode }),
      itemPrice: parseByCountry(cipl.goodsPrice.toString(), { country: this.accountCountryCode }),
      itemDetailEn: cipl.commodity.nameEn || cipl.name,
      itemDetail: cipl.commodity.nameId || cipl.name,
      commodityHsCode: ""
    }));
  }
  get ftzCommodityCipl() {
    return this.form.ftzForm.listCommodityCIPL?.map((cipl: any) => ({
      quantity: parseByCountry(cipl.quantity.toString(), { country: this.accountCountryCode }),
      itemPrice: parseByCountry(cipl.goodsPrice.toString(), { country: this.accountCountryCode }),
      itemDetailEn: cipl.commodity?.nameEn || cipl.name,
      itemDetail: cipl.commodity?.nameId || cipl.name,
      commodityHsCode: cipl.commodity?.hsCode
    }));
  }
  get accountIsNonForeign() {
    return !AccountController.accountData.accountIsForeign;
  }

  get payload(): any {
    return {
      ...this.payloadSectionOne,
      ...this.payloadSectionTwo,
      ...this.payloadSectionThree
    };
  }

  get payloadSectionOne() {
    return {
      id: this.manualBookingData.sttId,
      isMixpack: false,
      sttNoRefExternal: this.form.referenceExternal,
      sttTaxNumber: this.form.ftzForm.taxNumber,
      sttGoodsEstimatePrice: this.parseNumber(
        this.form.estimationPrice
      ),
      sttGoodsStatus:
        typeof this.form.ftzForm.shipmentStatus === "string"
          ? this.form.ftzForm.shipmentStatus
          : this.form.ftzForm.shipmentStatus instanceof OptionsClass
          ? this.form.ftzForm.shipmentStatus.value
          : "ecommerce",
      sttOriginCityId: this.manualBookingData.sttOriginCityId,
      sttOriginDistrictId: this.manualBookingData.sttOriginDistrictId,
      sttDestinationCityId: this.destinationCity.cityCode,
      sttDestinationDistrictId: this.destinationCity.code,
      sttSenderName: this.form.sender,
      sttSenderPhone: `${this.form.phoneCodeSender.substring(1)}${
        this.form.phoneSender
      }`
    };
  }

  get payloadSectionTwo() {
    return {
      sttSenderAddress: this.form.addressSender,
      sttIsSaveSender: this.form.isSaveSender,
      sttRecipientName: this.form.receiver,
      sttRecipientAddress: this.form.addressReceiver,
      sttRecipientAddressType: this.form.addressReceiverType.value,
      sttRecipientPhone: `${this.form.phoneCodeReceiver.substring(1)}${
        this.form.phoneReceiver
      }`,
      sttIsSaveRecipient: this.form.isSaveReceiver,
      sttInsuranceType: this.form.insurance,
      sttProductType: this.form.productName,
      sttCommodityCode:
        typeof this.form.commodity === "object"
          ? this.form.commodity.code
          : this.form.commodity,
      sttCommodityId: this.form.commodity.id,
      sttClientSttId: this.manualBookingData.sttClient.clientId,
      sttVendorSttId: 0,
      sttIsCod: this.form.sttIsCod,
      sttIsDfod: this.form.sttIsDfod,
      sttRecipientEmail: this.form.docInternationalForm.email,
      sttDutyTaxTerms: this.configRule.interDutyTaxTerms?.rule === this.configValidationForm.NON_EDITABLE
        ? this.manualBookingData.sttDutyTaxTerms
        : this.form.docInternationalForm.dutyTaxTerms,
      sttKtpImage: this.form.docInternationalForm.imageIdUrl,
      sttTaxImage: this.form.docInternationalForm.imageTaxUrl,
      sttFtzKtpImage: this.form.ftzForm.imageIdUrl,
      sttFtzTaxImage: this.form.ftzForm.imageTaxUrl,
      sttFtzAttachFiles: [
        this.form.ftzForm.imageBeforePackingUrl,
        this.form.ftzForm.imageAfterPackingUrl
      ]
    };
  }

  get payloadSectionThree() {
    return {
      sttIsPad: false,
      sttCodAmount: this.codAmount,
      sttIsDo: false,
      sttIsWoodpacking: this.form.woodpacking,
      sttPieces: this.pieces,
      sttPiecePerPack: Number(this.form.sttPiecePerPack),
      sttNextCommodity: this.form.sttNextCommodity,
      sttShipmentId: this.form.sttShipmentId,
      postalCodeDestination:
        typeof this.form.postalCodeDestination === "object"
          ? this.form.postalCodeDestination?.name
          : this.form.postalCodeDestination,
      sttLastStatus: this.manualBookingData.sttLastStatus,
      sttNo: this.manualBookingData.sttNo,
      sttGrossWeight: this.totalGrossWeight,
      sttVolumeWeight: Number(
        this.totalVolumeWeight.toString().replace(",", ".")
      ),
      sttChargeableWeight: this.chargeableWeight,
      sttWeightAttachFiles: this.form.adjustmentWeightAttachments.filter(
        (item: string) => item
      ),
      sttAttachFiles: [
        this.form.docInternationalForm.imageBeforePackingUrl,
        this.form.docInternationalForm.imageAfterPackingUrl
      ].filter((img) => img) as any,
      sttCommodityDetail: this.manualBookingData.sttCommodityDetail,
      discountFavoritePercentage: 0,
      sttIdentityNumber: this.form.docInternationalForm.idNumber,
      sttInterTaxNumber: this.form.docInternationalForm.taxNumber,
      statusGoods: this.form.ftzForm.shipmentStatus.value,
      sttFtzCipl: this.ftzCommodityCipl,
      sttCipl: this.docInternationalCommodityCipl,
      sttFtzRecipientEmail: this.form.ftzForm.email,
      sttDutyTaxTerms: this.form.docInternationalForm.dutyTaxTerms
    };
  }
  get configValidationForm() {
    return ConfigValidationForm;
  }

  get deliveryFeeType() {
    if (this.manualBookingData.sttIsCod && this.manualBookingData.sttIsDfod)
      return "dfod";
    if (this.manualBookingData.sttIsCod) return "cod";
    return "non-cod";
  }
  async getInternationalDocConfig() {
    const resp = await InternationalDocumentController.getInternationalDocumentDetail(
      {
        dest: this.destinationCity.cityId,
        origin: this.districtDetail.cityId
      }
    );

    this.internationalDocumentDetailData = resp;
    this.currentIndex = 100;
  }
  validateCIPL(isFtz = false) {
    if (
      this.configRuleAdjustStt.config.ftzCipl.rule ===
        this.configValidationForm.NON_EDITABLE ||
      this.configRuleAdjustStt.config.interCipl.rule ===
        this.configValidationForm.NON_EDITABLE
    )
      return true;
    if (!this.internationalDocumentDetailData.commodity && !isFtz) return true;
    const validations: boolean[] = [];
    const ciplList = isFtz
      ? this.form.ftzForm.listCommodityCIPL
      : this.form.docInternationalForm.listCommodityCIPL;

    ciplList?.forEach((cipl) => {
      validations.push(!parseZodError(itemDetailSchema, cipl.name));
      validations.push(!parseZodError(quantitySchema, cipl.quantity));
      validations.push(!parseZodError(goodsPriceSchema, cipl.goodsPrice));
    });

    return !Object.values(validations).includes(false);
  }

  destinationDetail = new DistrictData();

  mapCodDfodDetail() {
    if (this.manualBookingData.sttIsCod && this.manualBookingData.sttIsDfod) {
      this.form.serviceType = "dfod";
      this.form.isCOD = true;
      this.form.isDFOD = true;
    } else if (
      this.manualBookingData.sttIsCod &&
      !this.manualBookingData.sttIsDfod
    ) {
      this.form.serviceType = "cod";
      this.form.isCOD = true;
      this.form.isDFOD = false;
    } else {
      this.form.serviceType = "non-cod";
      this.form.isDFOD = false;
      this.form.isCOD = false;
    }
  }

  get accountCountryCode() {
    return AccountController.accountData.countryCode;
  }

  async mapClientDetail() {
    if (this.manualBookingData.sttClient.clientId) {
      const resp = (await ClientManagementController.getDetailV2(
        this.manualBookingData.sttClient.clientId
      )) as DetailClientManagement;

      this.clientManagementDetail = resp;
      this.manualBookingData.sttClient.clientAlias = resp.clientAlias;
      ProductController.fetchVolumetricDivisors(resp.clientCountry);
    } else {
      ProductController.fetchVolumetricDivisors(
        this.manualBookingData.sttBookedByCountry ||
          this.accountCountryCode
      );
    }
  }

  mapPriceFromDetail(price: string, destinationCountry: string) {
    const priceFormat = parseByCountry(price, {
      country: this.accountCountryCode
    });
    return formatInputByCountry(priceFormat, {
      type: "money",
      country: destinationCountry
    });
  }

  async setDetailData() {
    if (!this.manualBookingData.sttNo) {
      return;
    }
    const originResp = (await LocationController.getDetailDistrictByDistrictCode(
      {
        districtCode: this.manualBookingData.sttOriginDistrictId
      }
    )) as DistrictData;

    await this.mapClientDetail();

    const destinationResp = (await LocationController.getDetailDistrictByDistrictCode(
      {
        districtCode: this.manualBookingData.sttDestinationDistrictId
      }
    )) as DistrictData;

    this.destinationDetail = await LocationController.getDetailDistrict({
      id: destinationResp.id
    });

    await LocationController.getDetailDistrict({
      id: originResp.id
    });

    const destinationData = new DistrictData({
      ...this.destinationDetail,
      cityId: this.manualBookingData.sttDestinationAddress?.cityId,
      cityName: this.manualBookingData.sttDestinationCityName,
      districtName: this.manualBookingData.sttDestinationDistrictName,
      name: this.manualBookingData.sttDestinationAddress?.districtNameCityName,
      id: this.manualBookingData.sttDestinationDistrictId,
      code: this.manualBookingData.sttDestinationDistrictId,
      countryCode: this.manualBookingData.sttDestinationAddress?.countryCode,
    });

    const isClient = this.manualBookingData.sttClient.clientName && this.isAccountPosOrInternal || AccountController.accountData.isAllClient;

    const isCrossCountryRoute =
      !!destinationData?.id &&
      destinationData.countryCode !== this.originCountryCode &&
      isClient;

    const isCrossCountryCod =
      isCrossCountryRoute &&
      (Boolean(this.manualBookingData.sttIsCod) ||
        Boolean(this.manualBookingData.sttIsCod));

    const mapPriceFromDetail = (price: string, destinationCountry: string) => {
    const priceFormat = parseByCountry(price, {
      country: this.accountCountryCode
    });
    return formatInputByCountry(priceFormat, {
      type: "money",
      country: destinationCountry
    });
  }

    const estimationPrice =
      isCrossCountryCod ?
      mapPriceFromDetail(this.manualBookingData.sttGoodsEstimatePrice, this.manualBookingData.sttDestinationAddress?.countryCode) :
      this.manualBookingData.sttGoodsEstimatePrice;

    const codAmount =
      isCrossCountryCod ?
      mapPriceFromDetail(this.manualBookingData.sttCodAmount, this.manualBookingData.sttDestinationAddress?.countryCode) :
      this.manualBookingData.sttCodAmount;
    this.form = new BookingV3({
      shipmentId: this.manualBookingData.sttShipmentId,
      sttNo: this.manualBookingData.sttNo,
      clientName: this.manualBookingData.sttClient,
      sttManual: this.manualBookingData.sttNo,
      referenceExternal: this.manualBookingData.sttNoRefExternal,
      sttShipmentId: this.manualBookingData.sttShipmentId,
      addressReceiverType: this.optionAddressReceiver,
      commodity: await this.optionCommodity(),
      woodpacking: this.manualBookingData.sttIsWoodPacking,
      serviceType: this.deliveryFeeType,
      estimationPrice: estimationPrice,
      productName: this.manualBookingData.sttProductTypeName,
      insurance:
        this.manualBookingData.sttInsuranceName.toLowerCase() ===
        "insurance basic"
          ? "basic"
          : "free",
      isCOD: this.manualBookingData.sttIsCod,
      isDFOD: this.manualBookingData.sttIsDfod,
      pieces: this.manualBookingData.SttPieces.map((piece: any) => ({
        ...piece,
        grossWeight: formatByCountry(piece.grossWeight, {
          type: "weight",
          country: this.accountCountryCode
        }),
        volumeWeight: formatByCountry(piece.volumeWeight, {
          country: this.accountCountryCode,
          type: "weight"
        }),
        errorHws: false,
        errorGrossWeight: "",
        errorVolumeWeight: ""
      })),
      sender: this.manualBookingData.sttSenderName,
      receiver: this.manualBookingData.sttRecipientName,
      postalCodeDestination: new DistrictData({
        name: this.manualBookingData.postalCodeDestination
      }),
      phoneSender: this.manualBookingData.sttSenderPhone,
      phoneReceiver: this.manualBookingData.sttRecipientPhone,
      phoneFlagSender: this.manualBookingData.sttSenderPhoneFlag,
      phoneFlagReceiver: this.manualBookingData.sttRecipientPhoneFlag,
      phoneCodeSender: this.manualBookingData.sttSenderPhoneCode,
      phoneCodeReceiver: this.manualBookingData.sttRecipientPhoneCode,
      destinationCity: destinationData,
      commodityCode: this.commodityCode,
      addressSender: this.manualBookingData.sttSenderAddress,
      addressReceiver: this.manualBookingData.sttRecipientAddress,
      ftzForm: this.ftzForm,
      docInternationalForm: this.docInternationalForm,
      sttPiecePerPack: this.manualBookingData.sttPiecePerPack,
      sttNextCommodity: this.manualBookingData.sttNextCommodity,
      bookedForCountry: this.manualBookingData.sttBookedByCountry
    });
    await this.getCountryList();
    await this.$nextTick();
    this.onUpdateCountryDetail();
    await this.$nextTick();

    this.mapCodDfodDetail();
    this.tempProductName = this.manualBookingData.sttProductTypeName;

    this.tempTotalPieces = JSON.parse(JSON.stringify(this.form.pieces));
    await this.$nextTick();
    if (this.manualBookingData.postalCodeDestination) {
      LocationController.setZipCodeData(
        new ZipCodeEntities(new Pagination(1, 10), [
          new DistrictData({
            name: this.manualBookingData.postalCodeDestination
          })
        ])
      );
    }
    // Assign codAmount after price and delivery type assign
    this.form.codAmount = codAmount;
    this.isFirstRender = false;
    this.currentIndex = 40;
    if (
      this.form.productName &&
      !this.listProducts.includes(this.form.productName)
    ) {
      this.listProducts.push(this.form.productName);
    }
  }

  get optionAddressReceiver() {
    return new OptionsClass({
      name: this.manualBookingData.sttRecipientAddressType,
      value: this.manualBookingData.sttRecipientAddressType
    });
  }

  async optionCommodity() {
    const resp = (await CommodityController.getCommodityDetail({
      id: this.manualBookingData.sttCommodityId
    })) as Commodity;
    return new OptionsClass({
      id: this.manualBookingData.sttCommodityId,
      name: this.manualBookingData.sttCommodityName,
      code: this.manualBookingData.sttCommodityCode,
      status: resp.commodity_status,
      isDangerousGoods: resp.isDangerousGoods,
      isQuarantine: resp.isQuarantine
    });
  }

  get destinationCity(): DistrictData {
    if (typeof this.form.destinationCity === "string") {
      return new DistrictData();
    }
    return this.form.destinationCity;
  }

  get commodityCode() {
    return new CommodityBookingV3({
      id: this.manualBookingData.sttCommodityId,
      name: this.manualBookingData.sttCommodityName,
      code: this.manualBookingData.sttCommodityCode
    });
  }

  get ftzForm() {
    if (!this.manualBookingData.sttFtzAttachFiles.length) {
      this.manualBookingData.sttFtzAttachFiles = ["", ""];
    }
    if (this.manualBookingData.sttFtzAttachFiles.length == 1)
      this.manualBookingData.sttFtzAttachFiles.push("");

    this.errorFtz.listCommodityCIPLDocInternational = [];

    this.manualBookingData.sttFtzCipl.forEach(() => {
      this.errorFtz.listCommodityCIPLDocInternational.push(["", "", ""]);
    });

    return new DocInternationalModelValueType({
      email: this.manualBookingData.sttFtzRecipientEmail,
      idNumber: this.manualBookingData.sttFtzIdentityNumber,
      imageAfterPackingUrl: this.manualBookingData.sttFtzAttachFiles[1],
      imageBeforePackingUrl: this.manualBookingData.sttFtzAttachFiles[0],
      imageIdUrl: this.manualBookingData.sttFtzKtpImage,
      imageTaxUrl: this.manualBookingData.sttFtzTaxImage,
      shipmentStatus: this.manualBookingData.sttSenderStatus,
      listCommodityCIPL: this.manualBookingData.sttFtzCipl.map((cipl: any) => {
        return new CommodityCIPL({
          id: new Date().getTime() + Math.random(),
          commodity: {
            name: this.accountIsNonForeign
              ? cipl.item_detail
              : cipl.item_detail_en,
            nameId: cipl.item_detail,
            nameEn: cipl.item_detail_en,
            code: cipl.item_detail
          } as any,
          goodsPrice: this.formatPrice(cipl.item_price),
          name: cipl.item_detail,
          quantity: cipl.quantity.toString()
        });
      }),
      taxNumber: this.manualBookingData.sttTaxNumber
    });
  }

  get docInternationalForm() {
    if (!this.manualBookingData.sttAttachFiles.length) {
      this.manualBookingData.sttAttachFiles = ["", ""];
    }

    if (this.manualBookingData.sttAttachFiles.length == 1)
      this.manualBookingData.sttAttachFiles.push("");

    this.errorDocInternational.listCommodityCIPLDocInternational = [];

    this.manualBookingData.sttCipl.forEach(() => {
      this.errorDocInternational.listCommodityCIPLDocInternational.push([
        "",
        "",
        ""
      ]);
    });

    return new DocInternationalModelValueType({
      email: this.manualBookingData.sttRecipientEmail,
      idNumber: this.manualBookingData.sttIdentityNumber,
      imageAfterPackingUrl: this.manualBookingData.sttAttachFiles[1],
      imageBeforePackingUrl: this.manualBookingData.sttAttachFiles[0],
      imageIdUrl: this.manualBookingData.sttKtpImage,
      imageTaxUrl: this.manualBookingData.sttTaxImage,
      shipmentStatus: new OptionsClass(),
      listCommodityCIPL: this.manualBookingData.sttCipl.map((cipl: any) => {
        return new CommodityCIPL({
          id: new Date().getTime() + Math.random(),
          commodity: {
            name: this.accountIsNonForeign
              ? cipl.item_detail
              : cipl.item_detail_en,
            nameId: cipl.item_detail,
            nameEn: cipl.item_detail_en,
            code: cipl.item_detail
          } as any,
          goodsPrice: this.formatPrice(cipl.item_price),
          name: cipl.item_detail,
          quantity: cipl.quantity.toString()
        });
      }),
      taxNumber: this.manualBookingData.sttInterTaxNumber,
      dutyTaxTerms: this.manualBookingData.sttDutyTaxTerms || "DAP",
    })
  }

  async getDetail() {
    await ShipmentBookingController.getEditBookingDetail({
      id: Number(this.$route.query.id),
      sttNo: String(this.$route.params.id),
      isAuth: this.$route.meta.isAuth as any,
      pageType: "adjustment"
    });

    await this.setDetailData();
  }

  async getAdjustmentStt() {
    MainAppController.closeErrorMessage();
    try {
      const resp = await ShipmentBookingController.getRuleAdjustmentStt({
        sttNo: this.manualBookingData.sttNo
      });
      this.configRuleAdjustStt = resp;
      if (this.formType === "client") {
        this.configRuleAdjustStt.config.tariff.rule = "SHOW";
      }
    } catch (error) {
      console.error("errorRuleAdjustmentStt: ", error);
    }
  }

  get manualBookingData(): any {
    return ShipmentBookingController.shipmentBookingDetail;
  }

  attachmentImages = [];
  storageImages = new Array(
    flags.flag_max_photo_for_weight_adjustment.getValue()
  ).fill("");
  disabledWeightAdjustment = true;
  async onUpload(params: UploadMultiple) {
    MainAppController.closeMessageModal();
    MainAppController.closeErrorMessage();
    MainAppController.showLoading();
    try {
      if (params.file) {
        const fileLink = await BookingController.uploadHydraFile(
          new UploadHydraFileRequest({
            attachFile: params.file,
            folderPath: "stt/"
          })
        );
        this.storageImages[params.index] = fileLink.data;
        this.form.adjustmentWeightAttachments[params.index] = fileLink.data;
        this.disabledWeightAdjustment =
          this.form.adjustmentWeightAttachments.filter((key: any) => key !== "")
            .length < 2;
      }
    } catch (err) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(err, this.$t("bookingShipment.error.uploadPhoto"))
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

  async onRemove(index: number) {
    MainAppController.closeMessageModal();
    MainAppController.closeErrorMessage();
    MainAppController.showLoading();
    try {
      const fileToDelete = this.storageImages[index];
      if (!fileToDelete) {
        MainAppController.closeLoading();
        return;
      }

      const del = await BookingController.deleteHydraFile(
        new DeleteHydraFileRequest({
          attachFiles: [fileToDelete]
        })
      );

      const statusDel = del.data[fileToDelete];
      if (statusDel) {
        this.storageImages[index] = "";
        this.form.adjustmentWeightAttachments[index] = "";
      }
      this.disabledWeightAdjustment =
        this.form.adjustmentWeightAttachments.filter((key: any) => key !== "")
          .length < 2;
      this.form.pieces = this.manualBookingData.piece = this.manualBookingData.SttPieces.map(
        (piece: any) => ({
          ...piece,
          grossWeight: piece.grossWeight.toString(),
          volumeWeight: piece.volumeWeight.toString(),
          errorHws: false,
          errorGrossWeight: "",
          errorVolumeWeight: ""
        })
      );
    } catch (err) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(err, "Gagal menghapus Foto ke storage!")
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

  showViewAdjustment = false;
  onClickWeightAdjustment() {
    const refs: any = this.$refs;
    this.showViewAdjustment = true;
    if (refs) {
      refs["section-weight-adjustment"].onClickAccordion();
    }
  }

  _customRound(fractionRule = 0.31, weightNumber = 0) {
    const fraction = weightNumber % 1;

    if (Number(fraction.toFixed(2)) >= fractionRule) {
      return Math.ceil(weightNumber);
    }

    return Math.floor(weightNumber);
  }

  async getUpsellingData() {
    if (!this.destinationCity.id || this.isFirstRender) return;
    if (AccountController.accountData.isInternalAccount) {
      this.upsellingData = [];
      this.loadingUpsellingData = true;
      await new Promise((resolve) => setTimeout(resolve, 1500));
      this.form.productName = this.form.productName || this.tempProductName;
      this.upsellingData = [
        new PosterProduct({
          productType: this.form.productName
        })
      ];
      this.fetchPromisesAfterGetUpselling.forEach((fn: any) => {
        this[fn as keyof EditBooking]();
      });
      this.fetchPromisesAfterGetUpselling = [];

      if (!this.originalForm.sttNo) {
        this.originalForm = JSON.parse(JSON.stringify(this.form));
        CreateBookingV3Controller.setDirty(false);
        this.loadingBeforeDirty = false;
      }
      this.loadingUpsellingData = false;
      return;
    }
    try {
      this.upsellingData = [];
      this.loadingUpsellingData = true;
      this.isErrorUpselling = false;
      this.errorRouteNotFound = false;
      const resp = await BookingController.postToGetPosterProduct(
        this.upsellingPayload
      );
      this.upsellingData = resp.map(
        (product: any) =>
          new PosterProduct({
            productType: product.name,
            estimateSla: product.sla,
            totalTariffAfterDiscount: product.total_tariff_after_discount,
            commissionRate: product.commission_rate,
            bookingCommission: product.booking_commission,
            isEmbargo: product.is_embargo,
            shippingCost: product.shipping_cost
          })
      );
      this.form.productName = this.form.productName || this.tempProductName;
      this.fetchPromisesAfterGetUpselling.forEach((fn: any) => {
        this[fn as keyof EditBooking]();
      });
      this.fetchPromisesAfterGetUpselling = [];

      // assign original form here because after mounted finished,
      // the form will be changed by upselling data from watcher
      if (!this.originalForm.sttNo) {
        this.originalForm = JSON.parse(JSON.stringify(this.form));
        CreateBookingV3Controller.setDirty(false);
        this.loadingBeforeDirty = false;
      }
    } catch (err) {
      this.upsellingData = [];
      this.isErrorUpselling = err?.response?.status >= 500;
      this.form.productName = "";
      this.loadingUpsellingData = false;
      this.errorRouteNotFound =
        err.response.data.message.id ===
        "Harga Shipping Surcharge dan Publish Rate untuk rute yang dipilih tidak tersedia";
    } finally {
      this.loadingUpsellingData = false;
    }
  }

  getUpsellingDataDebounced = debounce(async () => {
    await this.getUpsellingData();
  }, 500);

  async getCODConfig() {
    const res = await CodConfigurationController.getList(
      new ApiRequestList({
        page: 1,
        limit: 20
      })
    );

    const codConfig = res.data.find((config: DetailCodConfigurationRetail) => {
      return config.ccoName === "COD Retail";
    }) as DetailCodConfigurationRetail;
    const dfodConfig = res.data.find((config: DetailCodConfigurationRetail) => {
      return config.ccoName === "DFOD Retail";
    }) as DetailCodConfigurationRetail;
    const codInternationalClientConfig = new DetailCodConfigurationRetail(
      res.data.find(
        (config: DetailCodConfigurationRetail) =>
          config.ccoName === "COD International Client"
      )
    );

    this.ccoCodActive = codConfig;
    this.ccoDfodActive = dfodConfig;
    this.ccoCodProducts = codConfig.ccoProductType;
    this.ccoDfodProducts = dfodConfig.ccoProductType;
    this.configCodInternationalClient = codInternationalClientConfig;
  }

  async getHWSConfig() {
    const resp = await HeavyWeightSurchargeController.getDetailHeavyWeightSurcharge(
      { id: 1 }
    );
    this.heavyWeightSurchargeConfig = resp;
  }

  async getRoundingRulesConfig() {
    const resp = await ProductController.fetchProductConfigurationRule(
      new ProductConfigurationRuleRequestParams({
        page: 1,
        isNoLimit: true
      })
    );
    this.configurationRules = resp.data;
  }

  getPromoConfig = debounce(async () => {
    const destinationCity =
      this.form.destinationCity instanceof DistrictData
        ? this.form.destinationCity
        : new DistrictData();
    if (
      !destinationCity.id ||
      !this.form.productName ||
      !this.totalGrossWeight ||
      !this.totalGrossWeight
    )
      return;
    const resp = await PromoConfigurationController.getPromoConfigurationList(
      new PromoConfigurationListRequest({
        page: 1,
        limit: 2,
        origin: this.districtDetail.cityCode,
        destination: destinationCity.cityCode,
        productName: this.form.productName,
        status: "active,nearly-expired",
        grossWeight: this.totalGrossWeight,
        volumeWeight: this.totalVolumeWeight,
        chargeableWeight: this.chargeableWeight,
        appliedTo: "retail"
      })
    );
  }, 500);

  getInsuranceConfig = debounce(async () => {
    if (!this.form.estimationPrice) return;
    const resp = await InsuranceController.getInsurance(
      new ApiRequestList({
        isPagination: true,
        typeInsurance: this.form.insurance,
        goodsPrice: this.parseNumber(this.form.estimationPrice),
        country: AccountController.accountData.countryCode,
        accountType: this.clientlientIdForProductUpselling.accountType,
        accountRefId: this.clientlientIdForProductUpselling.accountRefId
      })
    );
    this.insuranceData = resp;
  }, 500);

  getInsuranceAvailability = debounce(async () => {
    if (this.accountCountryCode !== "MY") return;

    await BookingController.getInsuranceTypesDelivery({
      insuranceConfig: 2,
      originCountry: this.originCountry
    });
  }, 500);

  get insuranceBasic() {
    const basic = BookingController.insuranceTypeDelivery.data.find(
      (item: InsuranceTypeDeliveryData) => item.value === "basic"
    );

    return new InsuranceTypeDeliveryData(basic);
  }

  get originCountry() {
    return (
      this.districtDetail?.countryCode ??
      AccountController.accountData.countryCode
    );
  }

  get isExistingInsuranceApplied() {
    return (
      this.form.insurance !== "free"
    );
  }

  getEstimationPriceDebounced = debounce(async () => {
    if (
      [
        !this.destinationCity.id,
        !this.form.commodity.id,
        !this.form.estimationPrice,
        !this.form.productName
      ].includes(true)
    )
      return;
    if (this.loadingUpsellingData)
      return this.fetchPromisesAfterGetUpselling.push(
        "getEstimationPriceDebounced"
      );
    this.getEstimationPrice();
  }, 500);

  get estimationPricePayload() {
    return new GetEstimationPrice({
      originId: this.districtDetail.code,
      destinationId: this.destinationCity.code,
      commodityId: this.form.commodity.id,
      productType: this.form.productName,
      accountType: this.clientlientIdForProductUpselling.accountType,
      accountRefId: this.clientlientIdForProductUpselling.accountRefId,
      insuranceType: this.form.insurance,
      isWoodpacking: this.form.woodpacking,
      isHaveTaxId: !!this.form.ftzForm.taxNumber,
      pieces: this.form.pieces.map((piece: any) => ({
        pieceLength: piece.dimension.length,
        pieceWidth: piece.dimension.width,
        pieceHeight: piece.dimension.height,
        pieceGrossWeight: this.parseNumber(piece.grossWeight)
      })) as any,
      isCod:
        this.form.serviceType === "cod" || this.form.serviceType === "dfod",
      isDfod: this.form.serviceType === "dfod",
      codHandling: "",
      codAmount: this.codAmount,
      goodsPrice: this.goodsPrice,
      isDisablePromo: false,
      promoAppliedTo: this.form.shipmentId ? "shipment" : "retail",
      isPad: false,
      shipmentPrefix: this.estimationShipmentPrefix(this.form.shipmentId),
      hideError: false,
      discountFavoritePercentage: 0,
      shipmentCreatedAt: this.manualBookingData.shipmentCreatedAt,
      sttBookedAt: this.manualBookingData.sttCreatedAt
    });
  }

  async getEstimationPrice() {
    try {
      this.loadingEstimationPrice = true;
      this.errorEstimationPrice = false;
      const resp = (await BookingController.getEstimationPriceForNewBooking(
        this.estimationPricePayload
      )) as EstimationPrice;
      this.estimationPriceData = resp;
    } catch (err) {
      if (err?.response?.status >= 500) {
        this.errorEstimationPrice = true;
      }
    } finally {
      this.loadingEstimationPrice = false;
    }
  }

  async onUpdateBooking(type: string) {
    if (MainAppController.loadingModal) return;
    this.focusTrap = null;
    this.isShowModalSuccessBooking = false;
    this.isShowModalFailedBooking = false;
    try {
      MainAppController.showLoading();
      if (
        !this.insuranceBasic &&
        !this.isExistingInsuranceApplied &&
        this.accountCountryCode === "MY"
      ) {
        this.form.insurance = "free";
      }

      const resp = await BookingController.editBookingV3(
        new EditBookingV3(this.payload as any)
      );
      const params: Diskon = {
        isDiscount: resp.isDiscount,
        totalTariff: resp.totalDiscount + resp.totalAfterDiscount,
        totalAfterDiscount: resp.totalAfterDiscount,
        totalBeforeDiscount: resp.totalBeforeDiscount
      };
      this.setDiscount(params);
      const language = ["INTERPACK", "INTERPACKMAXI"].includes(
        this.manualBookingData.sttProductTypeName
      )
        ? "en"
        : AccountController.accountData.accountIsForeign ? "en" : "id";
      const book: any = await import(
        "@/app/ui/views/shipment/booking/create-booking/payment-detail/book.vue"
      );

      const printType: any = {
        "book-print-thermal": () =>
          book.default.methods.printThermal(
            this.payload.id,
            language,
            this.payload.sttNo
          ),
        "book-print-thermal-pdf": () =>
          book.default.methods.printBasic(
            this.payload.id,
            0,
            language,
            false,
            true,
            this.payload.sttNo
          ),
        "book-print-pdf": () =>
          book.default.methods.printBasic(
            this.payload.id,
            1,
            language,
            undefined,
            undefined,
            this.payload.sttNo
          )
      };
      this.isShowModalSuccessBooking = true;
      await this.$nextTick();
      this.focusTrap = createFocusTrap(
        (this.$refs["modal-success-ref"] as any).$el,
        {
          escapeDeactivates: true,
          allowOutsideClick: true,
          returnFocusOnDeactivate: true,
          clickOutsideDeactivates: false,
          onDeactivate: () => {
            this.isShowModalSuccessBooking = false;
            this.focusTrap = null;
          }
        }
      );
      this.focusTrap.activate();

      if (type === "book-print-later") {
        return;
      } else {
        return printType[type]();
      }
    } catch (err) {
      this.isShowModalFailedBooking = true;
      this.errorCause = err?.response?.data?.message?.id;
    } finally {
      MainAppController.closeLoading();
    }
  }

  onCloseSuccess() {
    this.goBack();
    this.isShowModalSuccessBooking = false;
  }

  closeModalError() {
    this.isShowModalFailedBooking = false;
  }

  discount: Diskon = {
    isDiscount: false,
    totalTariff: 0,
    totalAfterDiscount: 0,
    totalBeforeDiscount: 0
  };

  setDiscount(params: Diskon) {
    this.discount = {
      isDiscount: params.isDiscount,
      totalTariff: params.totalTariff,
      totalAfterDiscount: params.totalAfterDiscount,
      totalBeforeDiscount: params.totalBeforeDiscount
    };
  }

  formatPrice(value: number) {
    return formatByCountry(value, {
      type: "money",
      country: this.accountCountryCode,
      fractionDigits: 2
    });
  }

  prefixList = "T1,TKLP,TKP,C1,C2,AD,ACA,ACB,AO,AI,ARA,ARB,AG";
  sttNumberPrefix = "19LP,98LP,99LP,95LP";
  isShowSectionUpload = false;

  onCheckDisableWeightAdjustment() {
    const findPrefix = this.prefixList
      .split(",")
      .find((item: string) =>
        this.manualBookingData.sttShipmentId.toUpperCase().startsWith(item)
      );

    const findPrefixStt = this.sttNumberPrefix
      .split(",")
      .find((item: string) => this.form.sttNo.toUpperCase().startsWith(item));
    this.disabledWeightAdjustment = !!findPrefix || !!findPrefixStt;
    if (this.form.clientName.clientName) this.disabledWeightAdjustment = true;
    this.isShowSectionUpload = this.disabledWeightAdjustment;
  }

  get isErrorEmbargoDestination() {
    return (
      this.upsellingData.length > 0 &&
      this.upsellingData.every((item) => item.isEmbargo) &&
      !!this.form.destinationCity
    );
  }

  get isEditSttMY() {
    return this.form.bookedForCountry === "MY";
  }

  estimationShipmentPrefix(shipmentId: string) {
    const prefixList = ["AP", "AS", "ARA", "ARB", "AG", "AD"];
    const findPrefix = prefixList.find((item: string) =>
      shipmentId.toUpperCase()?.startsWith(item)
    );
    return findPrefix ?? "";
  }

  get isSidebarAndBreadcrumbV2() {
    return MainAppController.isSidebarAndBreadcrumbV2;
  }

  onEnterBooking(event: any) {
    const isOnProcessBooking =
      this.isShowModalSuccessBooking || this.isShowModalFailedBooking;
    if (event.key === "Enter") {
      this.currentIndex = 35;
      if (!this.isFormValid || isOnProcessBooking) {
        return;
      }
      this.onUpdateBooking("book-print-later");
    }
  }

  get schemaGoodsPriceType() {
    return this.isCustomerApps
      ? "shipment_ca"
      : this.isClient
      ? "client"
      : "retail";
  }

  async getCountryList() {
    await LocationController.getCountryList({
      search: "",
      status: "active",
      page: 1,
      limit: 200
    });
  }

  get countryList(): CountryData[] {
    return LocationController.countryData.countryData || [];
  }

  onUpdateCountryDetail() {
    if (!this.form.clientName.clientId) return;

    this.form.originCountry = new CountryData(
      this.countryList.find(
        (item) => item.code === this.clientManagementDetail.clientDistrict.countryCode
      )
    );

    if (this.destinationCity.countryCode) {
      this.form.destinationCountry = new CountryData(
        this.countryList.find(
          (item) => item.code === this.destinationCity.countryCode
        )
      )
    }
  }
}

export default EditBooking;
